import type { StyleSpecification } from "maplibre-gl";

export type BasemapId = "opentopo" | "satellite" | "osm";

/** Public glyph endpoint used by the airspace label layer. Raster basemaps
 * don't ship fonts, so any text-field layer needs this declared on the style
 * or MapLibre rejects the layer and rebuilds the style from scratch. */
const GLYPHS = "https://demotiles.maplibre.org/font/{fontstack}/{range}.pbf";

const OSM_STYLE: StyleSpecification = {
  version: 8,
  glyphs: GLYPHS,
  sources: {
    osm: {
      type: "raster",
      tiles: ["https://tile.openstreetmap.org/{z}/{x}/{y}.png"],
      tileSize: 256,
      attribution: "© OpenStreetMap contributors",
      maxzoom: 19,
    },
  },
  layers: [{ id: "osm", type: "raster", source: "osm" }],
};

const OPENTOPO_STYLE: StyleSpecification = {
  version: 8,
  glyphs: GLYPHS,
  sources: {
    topo: {
      type: "raster",
      tiles: ["https://a.tile.opentopomap.org/{z}/{x}/{y}.png"],
      tileSize: 256,
      attribution: "© OpenTopoMap (CC-BY-SA) / OSM",
      maxzoom: 17,
    },
  },
  layers: [{ id: "topo", type: "raster", source: "topo" }],
};

const SATELLITE_STYLE: StyleSpecification = {
  version: 8,
  glyphs: GLYPHS,
  sources: {
    sat: {
      type: "raster",
      tiles: [
        "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",
      ],
      tileSize: 256,
      attribution: "Esri World Imagery",
      maxzoom: 19,
    },
  },
  layers: [{ id: "sat", type: "raster", source: "sat" }],
};

export const BASEMAPS: Record<BasemapId, { label: string; style: StyleSpecification }> = {
  opentopo: { label: "Topo", style: OPENTOPO_STYLE },
  satellite: { label: "Satellite", style: SATELLITE_STYLE },
  osm: { label: "Street", style: OSM_STYLE },
};
